import { atom } from "@reatom/framework";
import { withLocalStorage } from "@reatom/persist-web-storage";

export const cardOrTable = atom(false, "cardsOrTable").pipe(
  withLocalStorage("cardsOrTable"),
);
